module.exports = __webpack_public_path__ + "static/media/TIB.73e7b658.svg";